import { render, staticRenderFns } from "./EmbedHeaderViewButtons.vue?vue&type=template&id=52aa25af"
import script from "./EmbedHeaderViewButtons.vue?vue&type=script&lang=js"
export * from "./EmbedHeaderViewButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports